(() => {
  
  // Get all cart attributes
  // すべてのカート属性を取得する
  const cartAttributes = document.querySelectorAll('input[name^="attributes"],select[name^="attributes"]');

  function postData(evt) {
    
    // create attributes data
    // 属性データを作成する
    const value = evt.target.value;
    const id = evt.target.id;
    const attributes = {
      "attributes": {
        [id]: value
      }
    };

    // ignore any cart attributes without an id (all cart attribute fields should have an id)
    // ID のないカート属性は無視します (すべてのカート属性フィールドには ID が必要です)
    if (!id) return false;
  
    // post data via fetch
    // フェッチ経由でデータをポストする
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(attributes),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  cartAttributes.forEach(element => {
    // add an event listener for each cart attribute
    // カート属性ごとにイベント リスナーを追加する
    element.addEventListener("input", postData);
  });

})();